export const INITIALIZE_APP_DATA = "INITIALIZE_APP_DATA";
export const ALL_COURSES_DATA = "ALL_COURSES_DATA";
export const ALL_EXTERNAL_COURSES_DATA = "ALL_EXTERNAL_COURSES_DATA";
export const ALL_QUIZES_DATA = "ALL_QUIZES_DATA";
export const UPDATE_COURSE_DATA = "UPDATE_COURSE_DATA";
export const UPDATE_EXTERNAL_COURSE_DATA = "UPDATE_EXTERNAL_COURSE_DATA";
